import workspaceQuery from '../../queries/salesLedger/SalesPaymentTermWorkspaceQuery.graphql';
import listQuery from '../../queries/salesLedger/SalesPaymentTermListQuery.graphql';
import instanceQuery from '../../queries/salesLedger/SalesPaymentTermQuery.graphql';
import defaultQuery from '../../queries/salesLedger/SalesPaymentTermDefault.graphql';
import mutationQuery from '../../mutations/salesLedger/SalesPaymentTermMutation.graphql';
import fragment from '../../fragments/salesLedger/SalesPaymentTermFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SalesPaymentTerm: EntityType = {
  type: 'SalesPaymentTerm',
  title: 'Payment Terms',
  formTitle: 'Payment Term',
  formUrl: '/Customers/PaymentTerm/Details/',
  workspaceUrl: '/Customers/PaymentTerm/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SALES_LEDGER_PAYMENT_TERMS',
};

export default SalesPaymentTerm;
